import React, { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons'
import * as generic from './generic.js';
import useLoadState from './useLoadState.js';
import useDfpSlot from './useDfpSlot.js';
import Clube from './Clube.js';
import Arbitro from './Arbitro.js';
import TabelaLine from './TabelaLine.js';
import './Tabela.css';

export default function Tabela(props) {
	const [ state, setState, render ] = useLoadState(

		{ selectedLine: null, por_grupo: true, tabela: [], showStats: false }, 

		() => { return [ props.campeonato, props.rodada, props.fase, state.por_grupo ]; },

		() => { return [ { url: "campeonato/" + props.campeonato + "/tabela", params: { fase: props.fase.id, rodada: props.rodada, sort: state.por_grupo ? "grupo" : "" } } ] },

		(result) => {
			setState((state) => ({ ...state, tabela: result[0].result.list || [], stats: result[0].result.stats, selectedLine: null, has_publico: result[0].result.has_publico }));
		}
	);

	var slot1 = {
		path: '/102307571/lance_tabelas/sticky_tabelas',
		id: 'div-gpt-ad-3495178-1-tabela',
		className: 'banner-bottom',
		size: [
			[970,90],
			[728,90],
			[320,50]
		]
	};

	var slot2 = {
		path: '/102307571/lance_tabelas/tabelas_arroba_01',
		id: 'div-gpt-ad-3495178-2-' + (state.por_grupo ? 1 : 0) + '-' + props.rodada + '-' + props.fase.id,
		className: 'banner-tabela',
		size: [
			//[336,280],
			[300,250]
		]
	};

	const dfp = null;//useDfpSlot(slot1);
	const dfp2 = useDfpSlot(slot2);
	const showGrupo = (props.fase.has_grupo > 0 && props.fase.has_mixed_grupo <= 0);
	const changePorGrupo = function(e) {
		setState((state) => ({ ...state, por_grupo: !state.por_grupo }));
	};

	const tabela = render(() => {
		let last_grupo = null;
		let fifa = false;
		let penalti = false;
		let prorrogacao = false;

		const stats = state.stats;

		let slotPos = 3;
		if (slotPos > state.tabela.length - 2) {
			slotPos = Math.max(0, state.tabela.length - 2);
		}

		return (
			<>
			{state.has_publico ?
				<div className="line header row" onClick={() => setState({ ...state, showStats: !state.showStats})}>
					<div className="row e100 line-data">
						<div className="e100 title-text">
							Estatísticas Jogo a Jogo
						</div>
						<div className="button">
							<FontAwesomeIcon icon={fa.faAngleDoubleLeft}/>
						</div>
					</div>
					<div className="line-stats">
						<div className="row line-stats-clubes">
							<div className="button">
								<FontAwesomeIcon icon={fa.faAngleDoubleRight}/>
							</div>
						</div>
						<div className={"number large"}>PP</div>
						<div className={"number large"}>I</div>
						<div className="number percent">IV%</div>
						<div className={"number currency"}>RL (R$)</div>
						<div className={"number currency"}>RB (R$)</div>
					</div>
				</div>
			:
				null
			}
			{state.tabela.map((item, i) => {
				let header = null;
				if (showGrupo && item.nome_grupo !== last_grupo && state.por_grupo) {
					last_grupo = item.nome_grupo;
					header = <div key={last_grupo} className="row title-grupo"><span className="">{last_grupo}</span></div>;
				}
				const selectLine = function() {
					if (state.selectedLine === item) {
						setState({ ...state, selectedLine: null });
					} else {
						setState({ ...state, selectedLine: item });
					}
				};
				if (item.arbitro?.principal?.fifa > 0 ||
					item.arbitro.auxiliar1?.fifa > 0 ||
					item.arbitro.auxiliar2?.fifa > 0 ||
					item.arbitro.quarto?.fifa > 0)
				{
					fifa = true;
				}
				if (item.penaltis === "S") {
					penalti = true;
				}
				if (item.prorrogacao === "S") {
					prorrogacao = true;
				}
				return (
					<Fragment key={item.id}>
						{i === slotPos ? dfp2 : null}
						{header}
						<TabelaLine clubeMap={props.clubeMap} selectedLine={state.selectedLine} onClick={selectLine} hasInfo={true} hasPublico={state.has_publico} item={item}/>
					</Fragment>
				);
			})}
			<div className="line row tabela-horario" onClick={() => (setState({ ...state, selectedLine: null }))}>
				<div className="column e100 line-data">
					<span>* Jogos com horário de Brasília</span>
					<span className="info-legenda">* Clique no jogo para ver mais informações</span>
					{fifa ? <span>* Árbitros em destaque são do quadro da FIFA</span> : null}
					{penalti ? <span><span className="penalti"></span>Placar de pênaltis</span> : null}
					{prorrogacao ? <span><span className="prorrogacao"></span>Placar de prorrogação</span> : null}
				</div>
				{state.has_publico ?
					<div className="line-stats tabela-legenda">
						<div className="column">
							<div className="row">
								<div className={"number large"}></div>
								<div className={"number large"}></div>
								<div className="number percent"></div>
								<div className={"number currency"}></div>
								<div className={"number currency"}></div>
							</div>
							<div className="legenda-colunas column">
								<span> <span>PP</span> Público Pagante </span>
								<span> <span>I </span> Ingressos à venda </span>
								<span> <span>%IV </span> Percentual de ingressos vendidos </span>
								<span> <span>RL </span> Renda Líquida </span>
								<span> <span>RB </span> Renda Bruta </span>
							</div>
						</div>
					</div>
				:
					null
				}
			</div>
			<div className="tabela-stats-title" onClick={() => (setState({ ...state, selectedLine: null }))}>Estatísticas da Rodada</div>
			<div className="tabela-stats" onClick={() => (setState({ ...state, selectedLine: null }))}>
				<div className="w20">
					<div className="title-stats">Gols</div>
					<div className="row subtitle-stats">
						<div className="cell">Total</div>
						<div className="cell">Média</div>
					</div>
					<div className="row">
						<div className="cell">{generic.fmtNumber(stats.gol.sum)}</div>
						<div className="cell">{generic.fmtNumber(stats.gol.avg, 1)}</div>
					</div>
					<div className="row subtitle-stats">
						<div className="cell">Mandante</div>
						<div className="cell">Visitante</div>
					</div>
					<div className="row">
						<div className="cell column">
							<span>{generic.fmtNumber(stats.golm.sum)}</span>
						</div>
						<div className="cell column">
							<span>{generic.fmtNumber(stats.golv.sum)}</span>
						</div>
					</div>
				</div>
				{state.has_publico ? (
				<>
					<div className="w15">
						<div className="title-stats">Ingressos</div>
						<div className="row subtitle-stats">
							<div className="cell">Total</div>
						</div>
						<div className="row">
							<div className="cell">{generic.fmtNumber(stats["in"].sum)}</div>
						</div>
						<div className="row subtitle-stats">
							<div className="cell">% Vendidos</div>
						</div>
						<div className="row">
							<div className="cell">{generic.fmtPercent(stats["in"].perc)}</div>
						</div>
					</div>
					<div className="w25">
						<div className="title-stats">Público Pagante</div>
						<div className="row subtitle-stats">
							<div className="cell">Total</div>
							<div className="cell">Média</div>
						</div>
						<div className="row">
							<div className="cell">{generic.fmtNumber(stats.pu.sum)}</div>
							<div className="cell">{generic.fmtNumber(stats.pu.avg, 1)}</div>
						</div>
						<div className="row subtitle-stats">
							<div className="cell">Min</div>
							<div className="cell">Max</div>
						</div>
						<div className="row">
							<div className="cell column">
								<span>{generic.fmtNumber(stats.pu.min.value)}</span>
								<div className="row">
									<Clube clubeMap={props.clubeMap} clube={stats.pu.min.id_clubem}/>
									x
									<Clube clubeMap={props.clubeMap} clube={stats.pu.min.id_clubev}/>
								</div>
							</div>
							<div className="cell column">
								<span>{generic.fmtNumber(stats.pu.max.value)}</span>
								<div className="row">
									<Clube clubeMap={props.clubeMap} clube={stats.pu.max.id_clubem}/>
									x
									<Clube clubeMap={props.clubeMap} clube={stats.pu.max.id_clubev}/>
								</div>
							</div>
						</div>
					</div>
					<div className="w25">
						<div className="title-stats">Renda Bruta</div>
						<div className="row subtitle-stats">
							<div className="cell">Total</div>
							<div className="cell">Média</div>
						</div>
						<div className="row">
							<div className="cell">{generic.fmtCurrency(stats.rb.sum)}</div>
							<div className="cell">{generic.fmtCurrency(stats.rb.avg)}</div>
						</div>
						<div className="row subtitle-stats">
							<div className="cell">Min</div>
							<div className="cell">Max</div>
						</div>
						<div className="row">
							<div className="cell column">
								<span>{generic.fmtCurrency(stats.rb.min.value)}</span>
								<div className="row">
									<Clube clubeMap={props.clubeMap} clube={stats.rb.min.id_clubem}/>
									x
									<Clube clubeMap={props.clubeMap} clube={stats.rb.min.id_clubev}/>
								</div>
							</div>
							<div className="cell column">
								<span>{generic.fmtCurrency(stats.rb.max.value)}</span>
								<div className="row">
									<Clube clubeMap={props.clubeMap} clube={stats.rb.max.id_clubem}/>
									x
									<Clube clubeMap={props.clubeMap} clube={stats.rb.max.id_clubev}/>
								</div>
							</div>
						</div>
					</div>
					<div className="w25">
						<div className="title-stats">Renda Líquida</div>
						<div className="row subtitle-stats">
							<div className="cell">Total</div>
							<div className="cell">Média</div>
						</div>
						<div className="row">
							<div className="cell">{generic.fmtCurrency(stats.rl.sum)}</div>
							<div className="cell">{generic.fmtCurrency(stats.rl.avg)}</div>
						</div>
						<div className="row subtitle-stats">
							<div className="cell">Min</div>
							<div className="cell">Max</div>
						</div>
						<div className="row">
							<div className="cell column">
								<span>{generic.fmtCurrency(stats.rl.min.value)}</span>
								<div className="row">
									<Clube clubeMap={props.clubeMap} clube={stats.rl.min.id_clubem}/>
									x
									<Clube clubeMap={props.clubeMap} clube={stats.rl.min.id_clubev}/>
								</div>
							</div>
							<div className="cell column">
								<span>{generic.fmtCurrency(stats.rl.max.value)}</span>
								<div className="row">
									<Clube clubeMap={props.clubeMap} clube={stats.rl.max.id_clubem}/>
									x
									<Clube clubeMap={props.clubeMap} clube={stats.rl.max.id_clubev}/>
								</div>
							</div>
						</div>
					</div>
				</>
				) :
					null
				}
			</div>
		</>);
	});

	return (
		<div className={"tabela" + (state.has_publico ? " has_publico" : "")} data-stats={state.showStats}>
			{showGrupo ? <div className="check-field" key="has_grupo"><label>Por grupo <input type="checkbox" defaultChecked={state.por_grupo} onChange={changePorGrupo}/><span></span></label></div> : null}
			{tabela}
			{dfp}
		</div>
	);
}
